import { Component } from '@theme/component';
class CorkMartLaserFaces extends Component {
  #controller; side = 'front';
  connectedCallback() { super.connectedCallback(); this.connect(); }
  updatedCallback() { super.updatedCallback(); this.connect(); }
  connect() {
    this.#controller?.abort(); this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    this.host = this.closest('cm-personalisation'); this.panel = this.closest('cm-laser-panel'); this.form = this.closest('form');
    this.host.addEventListener('change', this.onChange, options);
    this.addEventListener('input', this.summarise, options);
    this.addEventListener('cm:artwork-ready', this.summarise, options);
    this.addEventListener('click', this.onClick, options);
    this.addEventListener('keydown', this.onKey, options);
    this.addEventListener('invalid', this.onInvalid, { ...options, capture: true });
    this.form.addEventListener('formdata', this.onFormData, options);
    this.sync();
  }
  disconnectedCallback() { super.disconnectedCallback(); this.#controller?.abort(); }
  get enabled() { return Boolean(this.host.querySelector('[data-laser-extra][data-module="face2"]:checked')) && Boolean(this.querySelector('[data-face-panel="back"]')); }
  get summary() {
    return ['front', ...(this.enabled ? ['back'] : [])].map(side => {
      const scope = this.querySelector('[data-face-panel="' + side + '"]'); const creator = scope?.querySelector('cm-laser-creator');
      const text = scope?.querySelector('input[type="file"]')?.files?.[0]?.name || (creator?.creating ? creator.dataset.summary : '');
      return text ? this.querySelector('[data-face-tab="' + side + '"]').textContent.trim() + ': ' + text : '';
    }).filter(Boolean).join('\n');
  }
  sync() {
    const back = this.querySelector('[data-face-panel="back"]');
    if (!back) { this.querySelector('[data-face-tabs]').hidden = true; this.select('front'); return; }
    back.disabled = !this.enabled;
    this.querySelector('[data-face-tabs]').hidden = !this.enabled;
    if (!this.enabled) this.side = 'front';
    this.select(this.side); this.summarise();
  }
  select(side) {
    this.side = side === 'back' && this.enabled ? 'back' : 'front';
    for (const tab of this.querySelectorAll('[data-face-tab]')) { const active = tab.dataset.faceTab === this.side; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; }
    for (const panel of this.querySelectorAll('[data-face-panel]')) panel.hidden = panel.dataset.facePanel !== this.side;
    this.refresh();
  }
  refresh() { const creator = this.querySelector('[data-face-panel="' + this.side + '"] cm-laser-creator'); creator?.syncGallery(); creator?.refreshPreview(); }
  summarise = () => { const output = this.form.querySelector('[data-laser-summary]'); if (output) { output.textContent = this.summary; output.hidden = !output.textContent; } };
  onChange = event => { if (event.target.matches('[data-laser-extra]')) { this.sync(); this.panel.setCompletion(false); } else this.summarise(); };
  onClick = event => { const tab = event.target.closest('[data-face-tab]'); if (tab) this.select(tab.dataset.faceTab); };
  onKey = event => { const tab = event.target.closest('[data-face-tab]'); if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return; event.preventDefault(); this.select(event.key === 'Home' ? 'front' : event.key === 'End' ? 'back' : this.side === 'front' ? 'back' : 'front'); this.querySelector('[data-face-tab="' + this.side + '"]').focus(); };
  onInvalid = event => { const side = event.target.closest('[data-face-panel]')?.dataset.facePanel; if (side) this.select(side); };
  onFormData = event => { if (!this.enabled) for (const key of [...event.formData.keys()]) if (key.startsWith('properties[Back ') || key.startsWith('properties[_cm_back')) event.formData.delete(key); };
}
if (!customElements.get('cm-laser-faces')) customElements.define('cm-laser-faces', CorkMartLaserFaces);
